<template>
  <el-dialog
    title="模板详情"
    :visible.sync="dialogVisible"
    width="760px"
    append-to-body
  >
    <div class="detail-row">
      <span class="label required">模板名称</span>
      <span class="value">{{ detailData.tplName || "-" }}</span>
    </div>
    <div class="detail-section-title">联营模式</div>
    <div class="mode-title">收益共享</div>
    <el-table :data="detailData.shareList || []" border size="small">
      <el-table-column prop="sortNo" label="序号" width="80" align="center" />
      <el-table-column prop="capitalRatio" label="出资比例" align="center">
        <template slot-scope="{ row }">{{ row.capitalRatio }}%</template>
      </el-table-column>
      <el-table-column prop="incomeRate" label="收益率" align="center">
        <template slot-scope="{ row }">{{ row.incomeRate }}%</template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="dialogVisible = false">
        关闭
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "StoreCooperationConfigDetailDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => ({
        tplName: "",
        shareList: [],
      }),
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-row {
  margin-bottom: 16px;

  .label {
    display: block;
    color: #606266;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .required::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }

  .value {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
  }
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #606266;
}

.detail-section-title {
  color: #303133;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 400;
}

.mode-title {
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-bottom: none;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}
</style>
